import { useAuth, useFeatureFlags } from '@smarty/shared';

/**
 * Si quien entra es VENDEDOR de un drop: un miembro que carga ventas y no administra (ver
 * `rutasDelVendedorDrop`). El dueño y el gerente administran y ven todo lo del plan.
 *
 * 🪤 SÓLO CON UN ROL CONOCIDO. Mientras la sesión carga, el rol puede venir vacío; si «no sé» contara
 *    como vendedor, el dueño rebotaría a Ventas cada vez que abre el panel. Vacío es «todavía no»,
 *    y la base niega igual lo que no le toca (20260929150000).
 */
export function useSoyVendedorDelDrop(): boolean {
  const { userRole } = useAuth();
  const { planType } = useFeatureFlags();
  return planType === 'drop' && (userRole === 'employee' || userRole === 'cashier');
}
